export default __webpack_public_path__ + "fonts/nuckle_medium-webfont.woff";